import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

// Global styles first (resets)
import './styles/global.css';
import './styles/cui-helpers.css';
import './styles/responsive.css';

// Import ETAS Common UI PrimeReact theme
import '@etas-cui/common-ui-primereact-theme/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '@phosphor-icons/web/regular';
// Must load after the above: de-collides the @phosphor-icons/web font from the
// theme's identically-named "Phosphor" fonts.
import './styles/phosphor-web-fix.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
